<template>
  <main>

    <div class="path">
      <i class="el-icon-caret-right"></i>资源管理
      <i class="el-icon-arrow-right"></i>&nbsp;套餐购买记录
    </div>

    <div class="content_wrapper" :style="'width:' + (wrapperWidth*navCollapse) + 'vw;'">
      <el-form :inline="true" label-width="120px">
        <div class="item-wrapper">

          <div class="item-content clearfix">
            <el-form-item label="产品名称" style="margin-bottom: 0px;">
              <el-select v-model="product" @change="handleQuery" placeholder="请选择">
                <el-option
                  v-for="item in products"
                  :key="item.productKey"
                  :label="item.productName"
                  :value="item.productKey">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="handleQuery">查 询</el-button>
              <el-button type="primary" icon="el-icon-search" @click="handleReset">重 置</el-button>
            </el-form-item>
          </div>

        </div>
      </el-form>
    </div>

    <section class="content_wrapper" :style="'width:' + (wrapperWidth*navCollapse) + 'vw;'">
      <el-table
        :data="tableData.data"
        v-loading="loading"
        stripe
        style="width: 100%">
        <el-table-column
          prop="productName"
          label="产品名称"
          :width="150*navCollapse">
        </el-table-column>

<!--        <el-table-column-->
<!--          prop="wrapper.paramPicture.name"-->
<!--          label="套餐名称"-->
<!--          :width="130*navCollapse">-->
<!--        </el-table-column>-->

        <el-table-column
          prop=""
          label="类型"
          :width="100*navCollapse">
          <template slot-scope="scope">
            {{scope.row.purchaseType == 1 ? '新购' : (scope.row.purchaseType == 2 ? '续购' : (scope.row.purchaseType == 3 ? '升级' : '增购License'))}}
          </template>
        </el-table-column>

        <el-table-column
          prop=""
          label="720P图像数量（张/月）"
          :width="180*navCollapse">
          <template slot-scope="scope">
            {{scope.row.tokenNumber/1348}}
<!--            {{scope.row.durationType === 2 ? '张/月':'张/'+scope.row.duration+'天'}}-->
          </template>
        </el-table-column>

<!--        <el-table-column-->
<!--          prop=""-->
<!--          label="Token数量（万个）"-->
<!--          :width="150*navCollapse">-->
<!--          <template slot-scope="scope">-->
<!--            {{formattedPrice(scope.row.tokenNumber/10000)}}-->
<!--          </template>-->
<!--        </el-table-column>-->

<!--        <el-table-column-->
<!--          prop="maxQps"-->
<!--          label="访问并发（QPS/s）"-->
<!--          :width="150*navCollapse">-->
<!--        </el-table-column>-->

        <el-table-column
          prop=""
          label="购买时长"
          :width="100*navCollapse">
          <template slot-scope="scope">
            {{scope.row.duration}}{{scope.row.durationType === 1 ? '天':'月'}}
          </template>
        </el-table-column>

        <el-table-column
          prop="updateTime"
          label="购买时间"
          :width="170*navCollapse">
        </el-table-column>

<!--        <el-table-column-->
<!--          prop=""-->
<!--          label="到期日期"-->
<!--          :width="120*navCollapse">-->
<!--          <template slot-scope="scope">-->
<!--            {{scope.row.expireTime.slice(0,10)}}-->
<!--          </template>-->
<!--        </el-table-column>-->

        <el-table-column
          prop="licenseCount"
          label="License数量"
          :width="120*navCollapse">
        </el-table-column>

        <el-table-column
          prop=""
          label="购买总量"
          :width="140*navCollapse">
          <template slot-scope="scope">
            {{ scope.row.durationType === 1 ? (scope.row.tokenNumber/1348) : (scope.row.tokenNumber/1348) * scope.row.duration * scope.row.licenseCount}}
          </template>
        </el-table-column>

        <el-table-column
          prop="settlementFee"
          label="结算金额（元）"
          :width="120*navCollapse">
        </el-table-column>

        <el-table-column
          label="操作">
          <template slot-scope="scope">
<!--            <el-tooltip v-if="isExpire(scope.row.expireTime) || scope.row.durationType === 1" class="item" effect="dark" content="体验套餐或已过期套餐不能续购" placement="top-start">-->
<!--              <el-button disabled type="text" size="small" @click="openRepurchaseDialog(scope.row)" >续购</el-button>-->
<!--            </el-tooltip>-->
<!--            <el-button v-else type="text" size="small" @click="openRepurchaseDialog(scope.row)" >续购</el-button>-->

<!--            <el-tooltip v-if="canUpgrade(scope.row.expireTime)" class="item" effect="dark" content="套餐剩余有效期不足1个月或已过期不能升级" placement="top-start">-->
<!--              <el-button disabled type="text" size="small" @click="openUpgradeDialog(scope.row)">升级</el-button>-->
<!--            </el-tooltip>-->
<!--            <el-button v-else type="text" size="small" @click="openUpgradeDialog(scope.row)" >升级</el-button>-->

<!--            <el-tooltip v-if="canUpgrade(scope.row.expireTime)" class="item" effect="dark" content="套餐剩余有效期不足1个月或已过期不能升级" placement="top-start">-->
<!--              <el-button disabled type="text" size="small" @click="openAddLicenseDialog(scope.row)">增购License</el-button>-->
<!--            </el-tooltip>-->
<!--            <el-button v-else type="text" size="small" @click="openAddLicenseDialog(scope.row)" >增购License</el-button>-->

            <el-tooltip v-if="scope.row.durationType === 1" class="item" effect="dark" content="体验套餐不能续购" placement="top-start">
              <el-button disabled type="text" size="small" @click="openRepurchaseDialog(scope.row)" >续购</el-button>
            </el-tooltip>
            <el-button v-else type="text" size="small" @click="openRepurchaseDialog(scope.row)" >续购</el-button>

            <el-tooltip v-if="scope.row.durationType === 1" class="item" effect="dark" content="体验套餐不能升级" placement="top-start">
              <el-button disabled type="text" size="small" @click="openUpgradeDialog(scope.row)">升级</el-button>
            </el-tooltip>
            <el-button v-else type="text" size="small" @click="openUpgradeDialog(scope.row)" >升级</el-button>

            <el-tooltip v-if="scope.row.durationType === 1" class="item" effect="dark" content="体验套餐不能增购License" placement="top-start">
              <el-button disabled type="text" size="small" @click="openAddLicenseDialog(scope.row)">增购License</el-button>
            </el-tooltip>
            <el-button v-else type="text" size="small" @click="openAddLicenseDialog(scope.row)" >增购License</el-button>

            <el-button type="text" size="small" @click="openResourceDialog(scope.row)" >套餐信息</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="total">
      </el-pagination>
      <br>

      <div v-if="total > 0" class="tip-ol-box">
        <ul type="disc" class="tip-ol">
          <li>体验套餐不能续购、升级和增购License</li>
<!--          <li>已过期套餐不能续购</li>-->
<!--          <li>套餐剩余有效期不足1个月或已过期不能升级和增购License</li>-->
        </ul>
      </div>
      <div><br> </div>
    </section>

    <el-dialog v-if="cusOrderDetail.paramPicture" title="套餐信息" :visible.sync="dialogResourceVisible" width="70%">
      <div style="margin: 10px 0px; font-size: 16px; font-weight: bold;">资源规格</div>
      <div class="my-table" style="width: 66vw; ">
        <div>
          <div class="table-header">
            <span class="table-cell" style="margin-left: 2vw; width: 8vw;">套餐名称</span>
            <span class="table-cell" style="width: 18vw;">套餐规格</span>
            <span class="table-cell" style="width: 8vw;">License数量</span>
            <span class="table-cell" style="width: 8vw;">购买时长</span>
            <span class="table-cell" style="margin-left: 2vw; width: 8vw;">单价（元/License）</span>
            <span class="table-cell" style="width: 8vw;">总价（元）</span>
          </div>
          <hr style="margin-bottom: 0px; margin-top: 0px;">
        </div>

        <div>
          <div class="table-row">
            <span class="table-cell" style="margin-left: 2vw; width: 8vw;">{{cusOrderDetail.paramPicture.name}}</span>
            <span class="table-cell" style="width: 18vw;">{{cusOrderDetail.paramPicture.spec}}</span>
            <span class="table-cell" style="width: 8vw;">{{cusOrderDetail.orderDetail.licenseCount}}</span>
            <span class="table-cell" style="width: 8vw;">{{cusOrderDetail.orderDetail.duration}}{{cusOrderDetail.orderDetail.durationUnit === '天' ? '天' : '个月'}}</span>
            <span class="table-cell" style="margin-left: 2vw; width: 8vw; color: #EF6234; ">{{formattedPrice(cusOrderDetail.orderDetail.unitPrice/100)}}</span>
            <span class="table-cell" style="width: 8vw; color: #EF6234; font-weight: bold; font-size: 16px;">
                  {{formattedPrice(cusOrderDetail.orderInfo.realPrice/100)}}
            </span>
          </div>
          <hr style="margin-bottom: 0px; margin-top: 0px;" size=1 color="#ddd">
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogResourceVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <el-dialog v-if="quotaInfo.productKey" title="资源续购" :visible.sync="dialogRepurchaseVisible" width="70%">
      <div class="tip-ol-box">
        <ul type="disc" class="tip-ol">
          <li>续购只延长有效期，资源规格（720P图像数量和License数量）与当前资源规格保持一致</li>
          <li>资源价格按当前最新价格计算</li>
          <li>续购后立即生效</li>
        </ul>
      </div>
      <br>

      <div style="margin: 10px 0px; font-size: 16px; font-weight: bold;">资源规格</div>
      <div class="my-table" style="width: 66vw; ">
        <div>
          <div class="table-header">
            <span class="table-cell" style="margin-left: 2vw; width: 8vw;">套餐名称</span>
            <span class="table-cell" style="width: 18vw;">套餐规格</span>
            <span class="table-cell" style="width: 8vw;">License数量</span>
            <span class="table-cell" style="width: 10vw;">购买时长</span>
            <span class="table-cell" style="margin-left: 2vw; width: 8vw;">单价（元/License）</span>
            <span class="table-cell" style="width: 8vw;">总价（元）</span>
          </div>
          <hr style="margin-bottom: 0px; margin-top: 0px;">
        </div>

        <div>
          <div class="table-row">
            <span class="table-cell" style="margin-left: 2vw; width: 8vw;">{{paramPic.name}}</span>
            <span class="table-cell" style="width: 18vw;">{{paramPic.spec}}</span>
            <span class="table-cell" style="width: 8vw;">{{quotaInfo.licenseCount}}</span>
            <span class="table-cell" style="width: 10vw;">
              <el-select v-model="duration" placeholder="请选择" @change="handleChange">
                <el-option
                  v-for="item in durations"
                  :key="item"
                  :label="item + '个月'"
                  :value="item">
                </el-option>
              </el-select>
            </span>

            <span class="table-cell" style="margin-left: 2vw; width: 8vw; color: #EF6234; ">{{formattedPrice(unitPrice/100)}}</span>
            <span class="table-cell" style="width: 8vw; color: #EF6234; font-weight: bold; font-size: 16px;">
                  {{formattedPrice(settlementAmount/100)}}
            </span>
          </div>
          <hr style="margin-bottom: 0px; margin-top: 0px;" size=1 color="#ddd">

        </div>
      </div>

      <div style="margin-top: 20px;">
        <span class="tip-label">协议条款</span>
        <span class="tip-label" style="width: 50vw;">
          <el-checkbox v-model="checked" style="color: #666; font-size: 14px;">我已阅读并同意</el-checkbox>
          <a target="_blank" href="/static/agreements/user_agreement_v1.HTML" style="">《服务条款》</a>
        </span>
      </div>

      <br>
      <div slot="footer" class="dialog-footer">
        <el-button :disabled="!checked || settlementAmount < 0.01" type="primary" @click="handleBuy">购 买</el-button>
        <el-button @click="dialogRepurchaseVisible = false">取 消</el-button>
      </div>
    </el-dialog>


    <el-dialog v-if="quotaInfo.productKey" title="增购License" :visible.sync="dialogAddLicenseVisible" width="70%">
      <div class="tip-ol-box">
        <ul type="disc" class="tip-ol">
          <li>增购License只增加License数量，资源规格（720P图像数量和有效期）与当前资源规格保持一致</li>
          <li>资源价格按当前最新价格计算</li>
          <li>增购的License下个月生效</li>
        </ul>
      </div>
      <br>

      <div style="margin: 10px 0px; font-size: 16px; font-weight: bold;">资源规格</div>
      <div class="my-table" style="width: 66vw; ">
        <div>
          <div class="table-header">
            <span class="table-cell" style="margin-left: 2vw; width: 8vw;">套餐名称</span>
            <span class="table-cell" style="width: 18vw;">套餐规格</span>
            <span class="table-cell" style="width: 8vw;">购买时长</span>
            <span class="table-cell" style="width: 10vw;">License数量</span>
            <span class="table-cell" style="margin-left: 2vw; width: 8vw;">单价（元/License）</span>
            <span class="table-cell" style="width: 8vw;">总价（元）</span>
          </div>
          <hr style="margin-bottom: 0px; margin-top: 0px;">
        </div>

        <div>
          <div class="table-row">
            <span class="table-cell" style="margin-left: 2vw; width: 8vw;">{{paramPic.name}}</span>
            <span class="table-cell" style="width: 18vw;">{{paramPic.spec}}</span>
            <span class="table-cell" style="width: 8vw;">{{duration}}个月</span>
            <span class="table-cell" style="width: 10vw;">
              <el-input-number @change="handleChange" v-model="licenseCount" :min="10" :step="10"></el-input-number>
            </span>
            <span class="table-cell" style="margin-left: 2vw; width: 8vw; color: #EF6234; ">{{formattedPrice(unitPrice/100)}}</span>
            <span class="table-cell" style="width: 8vw; color: #EF6234; font-weight: bold; font-size: 16px;">
                  {{formattedPrice(settlementAmount/100)}}
            </span>
          </div>
          <hr style="margin-bottom: 0px; margin-top: 0px;" size=1 color="#ddd">

        </div>
      </div>

      <div style="margin-top: 20px;">
        <span class="tip-label">协议条款</span>
        <span class="tip-label" style="width: 50vw;">
          <el-checkbox v-model="checked" style="color: #666; font-size: 14px;">我已阅读并同意</el-checkbox>
          <a target="_blank" href="/static/agreements/user_agreement_v1.HTML" style="">《服务条款》</a>
        </span>
      </div>

      <br>
      <div slot="footer" class="dialog-footer">
        <el-button :disabled="!checked || settlementAmount < 0.01" type="primary" @click="handleBuy">购 买</el-button>
        <el-button @click="dialogAddLicenseVisible = false">取 消</el-button>
      </div>
    </el-dialog>


    <el-dialog v-if="quotaInfo.productKey" title="资源升级" :visible.sync="dialogUpgradeVisible" width="72%">
      <div class="tip-ol-box">
        <ul type="disc" class="tip-ol">
<!--          <li>资源规格允许在有效期大于1个月的情况下升级</li>-->
          <li>升级后的资源规格需大于当前资源规格，License数量和购买时长保持不变</li>
          <li>升级后图像总量和费用按月度平均后补齐</li>
          <li>资源升级价格以当前最新价格计算</li>
        </ul>
      </div>

      <div class="tip-box" style="margin-top: 40px;">
        <div>
          <span style="font-size: 20px; color: #3888d7; font-weight: 800; padding-right: 6px;">|</span>
          <span style="font-size: 18px; font-weight: bold;">配置选择</span>
        </div>
      </div>

      <div class="product-box">
        <div class="resource-box" style="margin-top: 20px;">
          <div class="tip-label">资源包</div>

          <div class="resource-package-box">
            <div v-for="param in params" :key="param.no" :class="selectedNo === param.no ? 'resource-package-box-1-selected': 'resource-package-box-1'" @click="handleSelect(param)">
              <div :class="selectedNo === param.no ? 'resource-package-box-2-selected': 'resource-package-box-2'">
                <div class="resource-package-desc">
                  <div class="resource-package-title">{{param.name}} </div>
                  <div class="resource-package-valid-date">{{param.spec}}</div>
                </div>
                <div class="resource-package-price">{{ formattedPrice(param.unitPrice/100) }}元</div>
              </div>
            </div>

          </div>
        </div>

        <div style="margin-top: 20px;">
          <span class="tip-label">协议条款</span>
          <span class="tip-label" style="width: 50vw;">
          <el-checkbox v-model="checked" style="color: #666; font-size: 14px;">我已阅读并同意</el-checkbox>
<!--          <el-link type="primary" style="margin-top: -2px; font-size: 14px;">《服务条款》</el-link>-->
          <a target="_blank" href="/static/agreements/user_agreement_v1.HTML" style="">《服务条款》</a>
        </span>
        </div>

        <br>
        <div style="line-height: 12px; font-size: 12px; color: #999;" v-if="purchaseType == 3 && settlementAmount > 0">
          <div>
            【升级前套餐与资费】套餐名称：{{cusOrderDetail.paramPicture.name}}
            套餐规格：{{cusOrderDetail.paramPicture.spec}}
            License数量：{{cusOrderDetail.orderDetail.licenseCount}}个
            月单价：{{formattedPrice(cusOrderDetail.paramPicture.unitPrice/100)}}元/License
          </div>
          <br>
          <div>
            【升级后套餐与资费】套餐名称：{{paramPic.name}}
            套餐规格：{{paramPic.spec}}
            License数量：{{cusOrderDetail.orderDetail.licenseCount}}个
            月单价：{{formattedPrice(paramPic.unitPrice/100)}}元/License
            月差价：{{formattedPrice((paramPic.unitPrice-cusOrderDetail.paramPicture.unitPrice)/100)}}元/License
            剩余有效月数：{{upgradeDuration}}个月
          </div>
        </div>
      </div>

      <div class="pay-box">
        <span>结算费用</span>
        <span class="total-price">{{formattedPrice(settlementAmount/100)}}元</span>
      </div>
      <br>
      <div slot="footer" class="dialog-footer">
        <el-button :disabled="!checked || settlementAmount < 0.01" type="primary" @click="handleBuy">购 买</el-button>
        <el-button @click="dialogUpgradeVisible = false">取 消</el-button>
      </div>
    </el-dialog>



  </main>
</template>

<style>
  .el-table .success-cell {
    background: #F0F9EB;
    font-weight: bold;
  }
</style>

<script>
import {mapState} from 'vuex'
import {
  reqProductQuotaRecord,
  reqResourcePicParam,
  reqResourcePicParams4Upgrade,
  reqCusOrderDetail,
  reqProductInfo,
  reqAliQuotaInfo,

  reqCalculatePrice,
  reqCheckUpgrade,
  reqQuotaInfo
} from '@/api'

export default {
  name: 'PurchasedResourcePackage',

  data() {
    return {
      widthRatio: 1.0,

      products: [],
      product: '',

      tableData: {},
      purchaseType: 0,
      loading: true,
      createTime: '',
      currentPage: 1,
      total: 0,
      pageSize: 15,

      paramPic: {},
      quotaInfo: {},
      dialogRepurchaseVisible: false,
      dialogAddLicenseVisible: false,
      dialogUpgradeVisible: false,
      dialogResourceVisible: false,
      durations: [1,2,3,6,12,18,24],
      duration: 0,
      licenseCount: 0, // 增购的license
      upgradeDuration: 0,
      unitPrice: 0,
      settlementAmount: 0,
      remainMonths: 0,
      checked: false,

      params: [],
      selectedNo: 0,

      cusOrderDetail: {},
      calculateInfo: {},

      tokensArray: [],
      tokens: 0,
      qpsArray: [],
      qps: 0,

      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },

  async mounted () {
    await this.getProduct()
    await this.getPurchasedResourcePackages()
  },

  methods: {

    async getQuotaInfo() {
      const result = await reqAliQuotaInfo('/quota/getQuotaInfo', this.quotaInfo.id)
      // console.log(result)
      if (result.code === 200 && result.data.durationType === 2) {
        this.duration = result.data.duration
      } else {
        this.$message.error('数据查询失败，错误信息: ' + result.message)
      }
    },

    async getProduct() {
      const result = await reqProductInfo('/product/getProductList', 1, 100)
      if (result.code === 200) {
        if (result.data.total > 0) {
          this.products = result.data.data.map(function(element) {
            return {"productKey": element.productKey, "productName": element.productName}
          })
          // this.product = this.products[0].productKey
        }
      }
    },

    async getPurchasedResourcePackages() {
      this.loading = true
      const result = await reqProductQuotaRecord('/product/getUpdateQuotaRecord', this.product, this.purchaseType, this.currentPage, this.pageSize)
      if (result.code === 200) {
        this.tableData = result.data
        this.loading = false
        this.total  = result.data.total
      } else {
        this.$message.error('数据查询失败，错误信息: ' + result.message)
      }
    },

    async handleCurrentChange(val) {
      this.currentPage = val
      await this.getPurchasedResourcePackages()
    },

    async handleQuery () {
      this.tableData = {}
      this.currentPage = 1
      await this.getPurchasedResourcePackages()
    },

    handleReset() {
      this.product = ''
      this.handleQuery()
    },

    async openRepurchaseDialog (row) {
      const result = await reqResourcePicParam(row.orderId)
      if (result.code === 0) {
        this.paramPic = result.data
        this.purchaseType = 2
        this.duration = row.duration
        this.licenseCount = row.licenseCount
        this.unitPrice =result.data.unitPrice

        this.quotaInfo = row
        this.checked = false
        await this.calculatePrice()
        this.dialogRepurchaseVisible = true
      } else {
        this.$message.error('数据查询失败，错误信息: ' + result.message)
      }
    },

    async openAddLicenseDialog (row) {
      const result = await reqResourcePicParam(row.orderId)
      if (result.code === 0) {
        this.paramPic = result.data
        this.purchaseType = 4
        // this.duration = row.duration
        this.licenseCount = row.licenseCount
        this.unitPrice =result.data.unitPrice

        this.quotaInfo = row
        this.checked = false
        await this.getQuotaInfo() // 调用阿里接口获取duration
        await this.calculatePrice()
        this.dialogAddLicenseVisible = true
      } else {
        this.$message.error('数据查询失败，错误信息: ' + result.message)
      }
    },

    async openUpgradeDialog (row) {
      const result = await reqResourcePicParams4Upgrade(row.orderId)
      if (result.code === 0) {
        if (result.data.length < 1) {
          this.$message({
            message: '当前套餐已是最大规格，无需升级',
            type: 'warning'
          })
          return
        }
        this.purchaseType = 3
        this.params = result.data
        this.quotaInfo = row
        this.licenseCount = row.licenseCount
        this.checked = false
        await this.getCusOrderDetail()
        await this.getQuotaInfo() // 调用阿里接口获取duration
        this.dialogUpgradeVisible = true
      } else {
        this.$message.error('数据查询失败，错误信息: ' + result.message)
      }
    },

    async openResourceDialog(row) {
      const result = await reqCusOrderDetail(row.orderId)
      if (result.code === 0) {
        this.cusOrderDetail = result.data
        this.dialogResourceVisible = true
      } else {
        this.$message.error('数据查询失败，错误信息: ' + result.message)
      }
    },

    handleSelect (param) {
      this.selectedNo = param.no
      this.paramPic = param
      this.calculateUpgradePrice()
    },

    async calculatePrice () {
      const row = this.quotaInfo
      // this.settlementAmount = this.unitPrice * row.licenseCount * this.duration
      this.settlementAmount = this.unitPrice * this.licenseCount * this.duration

      let orderConfirmWrapper = this.paramPic
      orderConfirmWrapper.licenseCount = this.licenseCount
      orderConfirmWrapper.settlementAmount = this.settlementAmount
      orderConfirmWrapper.productKey = row.productKey
      orderConfirmWrapper.purchaseType = this.purchaseType
      orderConfirmWrapper.resType = 1 //1-图像 2-token
      orderConfirmWrapper.duration = this.duration
      orderConfirmWrapper.unit = this.paramPic.unit
      orderConfirmWrapper.recordId = row.id
      await this.$store.dispatch('setOrderConfirmWrapper', {orderConfirmWrapper})
    },

    async calculateUpgradePrice () {
      const row = this.quotaInfo
      const expireDate = new Date(row.expireTime)
      const now = new Date()
      // const duration = expireDate.getMonth() - now.getMonth()
      const duration = this.duration
      this.upgradeDuration = duration
      const gapUnitPrice = this.paramPic.unitPrice - this.cusOrderDetail.paramPicture.unitPrice

      this.settlementAmount = gapUnitPrice * row.licenseCount * duration
      let orderConfirmWrapper = this.paramPic
      orderConfirmWrapper.licenseCount = row.licenseCount
      orderConfirmWrapper.settlementAmount = this.settlementAmount
      orderConfirmWrapper.productKey = row.productKey
      orderConfirmWrapper.purchaseType = this.purchaseType
      orderConfirmWrapper.resType = 1 //1-图像 2-token
      orderConfirmWrapper.duration = duration
      orderConfirmWrapper.unit = this.paramPic.unit
      orderConfirmWrapper.recordId = row.id
      orderConfirmWrapper.gapUnitPrice = gapUnitPrice
      orderConfirmWrapper.lastAliOrderId = row.orderId
      await this.$store.dispatch('setOrderConfirmWrapper', {orderConfirmWrapper})
    },

    async handleChange () {
      await this.calculatePrice()
    },

    handleBuy () {
      this.$router.push({
        path: '/orderConfirm',
        query: {productKey: this.quotaInfo.productKey}
      }).catch(err=>{})
    },

    async getCusOrderDetail () {
      const result = await reqCusOrderDetail(this.quotaInfo.orderId)
      if (result.code === 0) {
        this.cusOrderDetail = result.data
      } else {
        this.$message.error('数据查询失败，错误信息: ' + result.message)
      }
    },

    //  async canUpgrade (row) {
    //   const aliOrderId = row.orderId
    //   const expireTime = row.expireTime
    //
    //   const result = await reqCheckUpgrade(aliOrderId)
    //
    //   if (result.code === 0) {
    //     const date1 = new Date(expireTime)
    //     const now = new Date()
    //
    //     if (result.data === 0 && (date1 >= now)) {
    //       console.log(row.orderId, result)
    //       return 0
    //     } else {
    //       return 1
    //     }
    //   }
    //
    //   return 1
    // },

    formattedPrice (price) {
      return parseFloat(price).toFixed(2); // 保留两位小数
    },

    formattedFloat (num) {
      return parseFloat(parseFloat(num).toFixed(1)) // 保留两位小数
    },

    isExpire(expireTime) {
      const date1 = new Date(expireTime)
      const now = new Date()
      return date1 < now
    },

    canUpgrade (expireTime) {
      const expireDate = new Date(expireTime)
      const now = new Date()
      const nextMonDate = now.setMonth(now.getMonth() + 1)
      return expireDate < nextMonDate
    },

    // getUpgradeDuration (expireTime) {
    //   const expireDate = new Date(expireTime)
    //   expireDate.getMonth()
    //   const now = new Date()
    //   const nextMonDate = now.setMonth(now.getMonth() + 1)
    //   return expireDate < nextMonDate
    // }
  },

  computed: {
    ...mapState(['navCollapse', 'wrapperWidth']),
  }

}
</script>

<style scoped>

  main {
    display: flex;
    flex-direction: column;
  }

  .content_wrapper {
    width: 82vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 20px auto;
  }


  .tip-ol-box {
    background-color: rgba(96, 149, 242, 0.3);
    padding: 10px 0px;
  }

  .tip-ol {
    color: #0C129A;
    font-size: 12px;
    line-height: 24px;
  }


  .tip-box {
    display: flex;
    flex-direction: column;
  }

  .tip-tab {
    font-size: 13px;
    padding: 6px 10px;
    color: #666;
    background-color: rgba(243, 243, 243, 0.9);
    margin-right: 20px;
  }

  .tip-content {
    font-size: 14px;
    color: #666;
  }

  .product-box {
    display: flex;
    flex-direction: column;
  }

  .resource-box {
    display: flex;
    flex-direction: row;
  }

  .tip-label {
    font-size: 14px;
    color: #666;
    width: 10vw;
  }

  .resource-package-box {
    display: flex;
    flex-direction: column;
  }

  .resource-package-box-1 {
    display: flex;
    flex-direction: row;
    margin-bottom: 20px;
  }

  .resource-package-box-1:hover {
    border: solid 2px #409EFF;
  }

  .resource-package-box-1-selected {
    display: flex;
    flex-direction: row;
    margin-bottom: 20px;
    border: solid 2px #FF9933;
  }

  .resource-package-box-2 {
    display: flex;
    flex-direction: row;
    width: 50vw;
    padding-left: 24px;
    padding-top: 24px;
    padding-bottom: 24px;
    border: solid 1px #999;
  }

  .resource-package-box-2-selected {
    display: flex;
    flex-direction: row;
    width: 50vw;
    padding-left: 24px;
    padding-top: 24px;
    padding-bottom: 24px;
  }

  .resource-package-desc {
    display: flex;
    flex-direction: column;
    width: 45vw;
  }

  .resource-package-title {
    font-size: 16px;
    font-weight: 500;
    line-height: 26px;
  }

  .resource-package-valid-date {
    font-size: 12px;
    color: #666;
    line-height: 26px;
  }

  .resource-package-price {
    display: flex;
    justify-content: right;
    padding-top: 4px;
    font-size: 18px;
    font-weight: bold;
    color: #EF6234;
    text-align: right;
    width: 5vw;
    padding-right: 25px;
  }

  .resource-package-amount {
    border-top: solid 1px #999;
    border-bottom: solid 1px #999;
    border-right: solid 1px #999;
    padding: 25px;
  }

  .pay-box {
    margin-top: 50px;
    width: 100%;
    height: 40px;
    display: flex;
    flex-direction: row;
    justify-content: right;
    align-items: end;
  }

  .total-price {
    margin-left: 16px;
    margin-right: 20px;
    font-size: 22px;
    font-weight: bold;
    color: #EF6234;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/pages/CustomerCenter/PurchasedResourcePackage/PurchasedResourcePackage.vue